<template>
  <div class="invoice-info-display">
    <div class="invoice-info-card">
      <div class="company-name">{{ userInfo.name || '-' }}</div>
      <div class="info-row">
        <div class="info-item">
          <span class="label">{{ $t('纳税人识别号：') }}</span>
          <span class="value">{{ invoiceInfo.identifyNumber || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('开票银行：') }}</span>
          <span class="value">{{ invoiceInfo.bank || '-' }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item">
          <span class="label">{{ $t('开票电话：') }}</span>
          <span class="value">{{ invoiceInfo.invoiceTelephone || '-' }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('银行账号：') }}</span>
          <span class="value">{{ invoiceInfo.bankAccount || '-' }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item">
          <span class="label">{{ $t('发票类型：') }}</span>
          <span class="value">{{ invoiceInfo.invoiceType === 1 ? $t('增值税普通发票') : $t('增值税专用发票') }}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ $t('发票形式：') }}</span>
          <span class="value">{{ $t('电子发票') }}</span>
        </div>
      </div>
      <div class="info-row" v-if="invoiceInfo.invoiceType === 2 && invoiceInfo.invoiceForm === 1">
        <div class="info-item full-width">
          <span class="label">{{ $t('邮箱地址：') }}</span>
          <span class="value">{{ invoiceInfo.invoiceEmail || invoiceInfo.email || '-' }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-item full-width">
          <span class="label">{{ $t('开票地址：') }}</span>
          <span class="value">{{ invoiceInfo.invoiceAddress || '-' }}</span>
        </div>
      </div>
      <div class="edit-link" v-if="!waitPay">
        <es-button type="text" theme="primary" icon="es-icon-edit" @click="handleEdit">{{ $t('修改开票信息') }}</es-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InvoiceInfoDisplay',
  props: {
    invoiceInfo: {
      type: Object,
      required: true,
    },
    waitPay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  methods: {
    handleEdit() {
      this.$emit('edit')
    },
  },
}
</script>

<style lang="less" scoped>
.invoice-info-display {
  width: 100%;
  .invoice-info-card {
    background: #f5f5f580;
    border-radius: 8px;
    padding: 14px 20px;
    width: 100%;

    .company-name {
      line-height: 17px;
      font-size: 12px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 8px;
    }

    .info-row {
      display: flex;
      margin-bottom: 12px;

      &:last-child {
        margin-bottom: 0;
      }

      .info-item {
        display: flex;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
        color: #999999;
        &:first-child {
          width: 232px;
          margin-right: 24px;
        }
        &:nth-child(2n) {
          width: calc(100% - 256px);
          .value {
            width: calc(100% - 64px);
            white-space: pre-wrap;
          }
        }
        &.full-width {
          flex: 2;
          .value {
            width: calc(100% - 64px);
            white-space: pre-wrap;
          }
        }

        .label {
          min-width: 64px;
        }

        .value {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .edit-link {
      // .es-icon-edit {
      //   margin-right: 4px;
      //   font-size: 12px;
      // }
    }
  }
}
</style>
